import React from "react";
import LegalLayout from "../components/legal/LegalLayout";
import VerbalConsentSmsPolicy from "../components/legal/VerbalConsentSmsPolicy";

export default function VerbalConsentSmsPage() {
  return (
    <LegalLayout
      title={
        <>
          ClearBadge <span className="legal-title-gradient">Verbal Consent SMS</span>
        </>
      }
      eyebrow="SMS Compliance"
    >
      <VerbalConsentSmsPolicy />
    </LegalLayout>
  );
}
